import dayjs from "dayjs";

import { LocationKeywordData, LocationKeywordDataForCsv } from "../types";

export const convertSearchKeywordsDataToCsv = (
  data: LocationKeywordData[],
  dateFrom: dayjs.Dayjs,
  dateTo: dayjs.Dayjs
) => {
  const csvRows = [];
  const dates: string[] = getDatesInRange(dateFrom, dateTo);

  csvRows.push("location_name,keyword," + dates.join(","));
  const locationKeywordDataForCsv = convertSearchKeywordsDataFormatForCsv(data);
  locationKeywordDataForCsv.forEach((item) => {
    const escapedLocationName = item.location_name.replace(/"/g, '""');
    const escapedKeyword = item.keyword.replace(/"/g, '""');
    let row = `"${escapedLocationName}","${escapedKeyword}"`;
    for (const date of dates) {
      row =
        row + `,${item.data.find((data) => data.date === date)?.value || "0"}`;
    }
    csvRows.push(row);
  });
  return csvRows;
};

const getDatesInRange = (
  dateFrom: dayjs.Dayjs,
  dateTo: dayjs.Dayjs
): string[] => {
  const dates: string[] = [];
  let currentDate = dateFrom;
  while (currentDate.isBefore(dateTo)) {
    dates.push(currentDate.format("YYYY-MM"));
    currentDate = currentDate.add(1, "month");
  }
  return dates;
};

const convertSearchKeywordsDataFormatForCsv = (
  data: LocationKeywordData[]
): LocationKeywordDataForCsv[] => {
  const locationKeywordDataForCsv: LocationKeywordDataForCsv[] = [];
  const set: {
    [location: string]: {
      [keyword: string]: { date: string; value: number }[];
    };
  } = {};
  data.forEach((item) => {
    for (const year of Object.keys(item.data)) {
      for (const month of Object.keys(item.data[year])) {
        const date = dayjs(`${year}-${month.padStart(2, "0")}-01`);
        for (const keyword of item.data[year][month]) {
          // If the location is not in the set, add it
          if (!set[item.location_name]) {
            set[item.location_name] = {};
          }
          // If the keyword is not in the set, add it
          if (!set[item.location_name][keyword.keyword]) {
            set[item.location_name][keyword.keyword] = [];
          }

          // Add the date/value to the set
          set[item.location_name][keyword.keyword].push({
            date: date.format("YYYY-MM"),
            value: Number(keyword.value)
          });
        }
      }
    }
  });
  for (const locationName of Object.keys(set)) {
    for (const keyword of Object.keys(set[locationName])) {
      locationKeywordDataForCsv.push({
        location_name: locationName,
        keyword: keyword,
        data: set[locationName][keyword]
      });
    }
  }
  return locationKeywordDataForCsv;
};
